import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import { isNpsCsatConfigurable } from 'redux/selectors/analytics';

import ConfigureLink from './configure-link';
import NpsCsatConfigurationModal from './nps-csat-configuration-modal';

const NpsCsatConfigurationWrapper = () => {

  const isConfigurable = useSelector(isNpsCsatConfigurable);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div>
      {isConfigurable && <ConfigureLink onClick={openModal} />}
      {isModalOpen && <NpsCsatConfigurationModal onClose={closeModal} />}
    </div>
  );
};

export default NpsCsatConfigurationWrapper;
